<template>
  <div class="card fade-in rounded-card mb-3">
    <router-link :to="{ name: 'PostDetails', params: { id: post.posts_id } }" class="card-link">
      <div class="card-header border-0 pb-0">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <div class="avatar me-2">
              <a href="#!">
                <img class="avatar-img rounded-circle"
                  :src="post.user_image || post.users_image ? `https://zadcodeonline.com//ahmad/etqan/backEnd/upload/profile/${post.user_image}` : '/assets/images/avatar/default-avatar.jpg'"
                  alt="Profile">
              </a>
            </div>

            <div class="me-2">
              <div class="nav nav-divider">
                <router-link to="#" class="text-person">
                  {{ post.user_name || post.users_name }}
                </router-link>
                <router-link to="#" style="font-size: 0.9rem;" class="text-person-city me-1">
                  - {{ post.city_name }}
                </router-link>
              </div>
              <span class="text-date">
                {{ formatTimeAgo(post.posts_created_date) }} - {{ post.categories_name || 'غير معروف' }}
              </span>
            </div>
          </div>
          <div class="dropdown">
            <a href="#" class="text-secondary btn btn-secondary-soft-hover py-1 px-2"
              @click.prevent="toggleSave(post.posts_id)">
              <!-- استخدام المتغير المحلي isSaved -->
              <i v-if="isSaved" class="fa-bookmark fa-solid fs-3" style="color:#FFD700"></i>
              <i v-else class="far fa-bookmark fs-3" style="color:#296080"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="card-body">
        <p class="mb-0" style="color: #296080; font-size: 1.1rem;">{{ post.posts_title }}</p>
        <p>{{ post.posts_description }}</p>
        <!-- <div v-if="post.images && post.images.length" class="post-images-container">
            <div v-if="post.images.length === 1" class="single-image">
              <img :src="`https://zadcodeonline.com//ahmad/etqan/backEnd/upload/post/${post.images[0]}`"
                alt="Post Image" class="img-fluid rounded">
            </div>
            <div v-else-if="post.images.length === 2" class="two-images d-flex">
              <img v-for="(image, index) in post.images.slice(0, 2)" :key="index"
                :src="`https://zadcodeonline.com//ahmad/etqan/backEnd/upload/post/${image}`"
                alt="Post Image" class="img-fluid rounded me-1">
            </div>
            <div v-else-if="post.images.length >= 3" class="three-or-more-images">
              <div class="main-image">
                <img :src="`https://zadcodeonline.com//ahmad/etqan/backEnd/upload/post/${post.images[0]}`"
                  alt="Post Image" class="img-fluid rounded">
              </div>
              <div class="other-images d-flex">
                <img v-for="(image, index) in post.images.slice(1, 3)" :key="index"
                  :src="`https://zadcodeonline.com//ahmad/etqan/backEnd/upload/post/${image}`"
                  alt="Post Image" class="img-fluid rounded me-1">
                <div v-if="post.images.length > 3" class="overlay">
                  <span>+{{ post.images.length - 3 }}</span>
                </div>
              </div>
            </div>
          </div> -->

        <div v-if="post.images && post.images.length" class="post-images-container">
          <!-- حالة صورة واحدة -->
          <div v-if="post.images.length === 1" class="single-image">
            <img :src="`https://zadcodeonline.com/ahmad/etqan/backEnd/upload/post/${post.images[0]}`" alt="Post Image"
              class="img-fluid rounded" />
          </div>

          <!-- حالة صورتين -->
          <div v-else-if="post.images.length === 2" class="two-images d-flex">
            <img v-for="(image, index) in post.images.slice(0, 2)" :key="index"
              :src="`https://zadcodeonline.com/ahmad/etqan/backEnd/upload/post/${image}`" alt="Post Image"
              class="img-fluid rounded me-1" />
          </div>

          <!-- حالة ثلاث صور فأكثر -->
          <div v-else-if="post.images.length >= 3" class="three-or-more-images">
            <!-- الصورة الرئيسية (الأولى) -->
            <div class="main-image mb-2">
              <img :src="`https://zadcodeonline.com/ahmad/etqan/backEnd/upload/post/${post.images[0]}`" alt="Post Image"
                class="img-fluid rounded w-100" style="height: 200px; object-fit: cover;" />
            </div>

            <!-- الصور الثانية والثالثة جنبًا إلى جنب -->
            <div class="other-images d-flex justify-content-between">
              <!-- نعرض فقط الصورتين (index: 1, 2) -->
              <div class="position-relative" v-for="(image, index) in post.images.slice(1, 3)" :key="index"
                style="width: 49%;">
                <img :src="`https://zadcodeonline.com/ahmad/etqan/backEnd/upload/post/${image}`" alt="Post Image"
                  class="img-fluid rounded w-100" style="height: 100px; object-fit: cover;" />
                <!-- إذا كان لدينا أكثر من 3 صور، نعرض الأوفرلاي على الصورة الأخيرة (الثالثة) -->
                <div v-if="index === 1 && post.images.length > 3"
                  class="overlay d-flex align-items-center justify-content-center rounded w-100 h-100"
                  style="position: absolute; top: 0; left: 0; background-color: rgba(0,0,0,0.4);">
                  <span style="font-size: 24px; color: #fff;">+{{ post.images.length - 3 }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="d-flex align-items-center justify-content-between">
            <ul class="nav nav-stack py-3 small">
              <li class="nav-item">
                <a class="nav-link" href="#!" @click.prevent="toggleLike(post.posts_id)">
                  <!-- استخدام المتغير المحلي isFavorite و favoritCount -->
                  <i v-if="isFavorite" class="fa-solid fa-heart fs-5" style="color: red"></i>
                  <i v-else class="fa-regular fa-heart fs-5"></i>
                  <span>{{ favoritCount }}</span>
                </a>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :to="{ name: 'PostCommetDetailsPage', params: { id: post.posts_id } }">
                  <i class="fa-regular fa-comment fs-5"></i>
                </router-link>
              </li>
            </ul>
            <ul class="nav nav-stack py-3 small">
              <li v-if="isMyPost" class="nav-item">
                <router-link class="nav-link btn-prices" style="margin-left: 10px; color: #fff !important;"
                  :to="{ name: 'PricesPage', params: { id: post.posts_id } }" @click="sharePost(post.posts_id)">
                  عروض الاسعار
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :to="{ name: 'ChatPage', params: { id: 1 } }"
                  @click="sharePost(post.posts_id)">
                  <i class="fas fa-paper-plane fs-5"></i>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "PostCard",
  props: {
    post: {
      type: Object,
      required: true,
    },
    isMyPost: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      // إنشاء متغيرات محلية بناءً على بيانات الـ prop
      isSaved: this.post.is_saves,
      isFavorite: this.post.is_favorite,
      favoritCount: this.post.posts_favorit_count,
    };
  },
  watch: {
    // تحديث المتغيرات المحلية إذا تغير الـ prop من الخارج
    post(newVal) {
      this.isSaved = newVal.is_saves;
      this.isFavorite = newVal.is_favorite;
      this.favoritCount = newVal.posts_favorit_count;
    }
  },
  methods: {
    async toggleSave(postId) {
      // تحديث الحالة في الواجهة عبر المتغير المحلي isSaved
      this.isSaved = !this.isSaved;

      try {
        const userId = localStorage.getItem("userId");
        if (!userId) {
          alert("يجب تسجيل الدخول أولاً");
          this.$router.push({ name: 'Login' });
          return;
        }

        const response = await axios.post(
          'https://zadcodeonline.com/ahmad/etqan/backEnd/posts/addordelete_save.php',
          {
            postIdOrfreelancId: postId,
            typeadd: 1,
            userId: userId
          },
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Accept': 'application/json'
            },
          }
        );

        if (response.data.status === 'success') {
          console.log(response.data);
        }
      } catch (error) {
        console.error('Error toggling save:', error);
      }
    },
    async toggleLike(postId) {
      // تعديل الحالة والعداد باستخدام المتغيرات المحلية isFavorite و favoritCount
      if (this.isFavorite) {
        this.isFavorite = false;
        this.favoritCount--;
      } else {
        this.isFavorite = true;
        this.favoritCount++;
      }

      try {
        const userId = localStorage.getItem("userId");
        if (!userId) {
          alert("يجب تسجيل الدخول أولاً");
          this.$router.push({ name: 'Login' });
          return;
        }

        const response = await axios.post(
          'https://zadcodeonline.com/ahmad/etqan/backEnd/posts/addordelete_like.php',
          {
            postId: postId,
            userId: userId
          },
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Accept': 'application/json'
            },
          }
        );

        if (response.data.status === 'success') {
          console.log(response.data);
        }
      } catch (error) {
        console.error('Error toggling like:', error);
      }
    },
    sharePost(postId) {
      console.log("Sharing post:", postId);
    },
    formatTimeAgo(dateString) {
      const postDate = new Date(dateString);
      const now = new Date();
      const diffInSeconds = Math.floor((now - postDate) / 1000);
      if (diffInSeconds < 60) {
        return `منذ ${diffInSeconds} ثانية`;
      } else if (diffInSeconds < 3600) {
        const minutes = Math.floor(diffInSeconds / 60);
        return `منذ ${minutes} دقيقة`;
      } else if (diffInSeconds < 86400) {
        const hours = Math.floor(diffInSeconds / 3600);
        return `منذ ${hours} ساعة`;
      } else {
        const days = Math.floor(diffInSeconds / 86400);
        return `منذ ${days} يوم${days > 1 ? '' : ''}`;
      }
    },
  },
};
</script>



<style scoped>
.btn-prices {
  color: #fff !important;
  background-color: #296080 !important;
  padding: 0.6rem 1rem;
  border-radius: 15px !important;
}

.card-header {
  color: #296080;
  background-color: #fff !important;
  padding: 1rem 1rem;
  border-radius: 15px !important;
}

.card-body {
  background-color: #fff !important;
  padding: 1.25rem 1.25rem 0 1.25rem;
}

li {
  display: inline-block;
  margin: 0 0 !important;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  color: #333;
  transition: color 0.3s ease;
}

.nav {
  align-items: center;
}

.nav-link:hover {
  color: #296080;
}

.loading-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 9999;
}

.spinner-border {
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.fade-in {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeIn 0.8s ease-out forwards;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.three-or-more-images {
  display: block; /* أو flex إذا أردت توزيعًا مختلفًا */
}

.three-or-more-images .main-image img {
  width: 100%;
  height: 200px;         /* ارتفاع مناسب للصورة الرئيسية */
  object-fit: cover;     /* ملء الصورة مع الحفاظ على النسبة */
  border-radius: 15px;
}

.three-or-more-images .other-images {
  display: flex;
  justify-content: space-between;
  gap: 5px;              /* مسافة بين الصور */
}

.three-or-more-images .other-images img {
  border-radius: 15px;
  transition: transform 0.3s, box-shadow 0.3s;
  object-fit: cover;
}

.three-or-more-images .other-images img:hover {
  transform: scale(1.02);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

.overlay {
  /* يُفضَّل استخدام position: absolute لضبط مكان الأوفرلاي فوق الصورة الأخيرة */
  position: absolute;
  top: 0;
  left: 0;
  /* لون خلفية شفاف */
  background-color: rgba(0, 0, 0, 0.4);
  color: #fff;
  font-size: 1.2rem;
  border-radius: 15px;
  text-align: center;
}


.carousel-caption h5 {
  font-size: 1.5rem;
  color: #fff;
}

.carousel-caption p {
  font-size: 1rem;
  color: #fff;
}

a {
  color: #296080;
}



h3 {
  /* margin: 40px 0 0; */
  margin: 40px 0 10px;
  font-size: 1.8rem;
  color: #333;
  font-weight: 600;
  text-align: center;
}

/* تحسين القوائم */
ul {
  list-style-type: none;
  padding: 0;
  text-align: center;
}

li {
  display: inline-block;
  margin: 0 15px;
}

a {
  color: #296080;
  font-size: 1.1rem;
  text-decoration: none;
  transition: color 0.3s ease;
}

a:hover {
  color: #004d73;
  /* font-weight: bold; */
}

.text-itkan {
  font-size: 25px;
  color: #ffffff;
}

.text-person {
  font-weight: bold;
  color: #296080;
  font-size: 1.2rem;
}

.text-date {
  font-size: 0.7rem;
  color: #6c757d;
}

.rounded-card {
  border-radius: 20px !important;
  overflow: hidden;
}

.carousel-item img {
  border-radius: 30px;
  height: 200px;
  object-fit: cover;
}

@media (max-width: 992px) {
  .carousel-item img {
    border-radius: 30px;
    height: 200px;
    object-fit: cover;
  }

  .row>* {
    margin-top: 10px;
  }
}

@media (max-width: 992px) {
  .navbar-light .navbar-nav .nav-link[data-v-5e4cad4c] {
    color: #296080;
  }

  .navbar>.container,
  .navbar>.container-fluid,
  .navbar>.container-sm,
  .navbar>.container-md,
  .navbar>.container-lg,
  .navbar>.container-xl,
  .navbar>.container-xxl {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: inherit;
    flex-wrap: inherit;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    flex-direction: row-reverse;
  }
}

body {
  background: linear-gradient(to bottom, #f5f7fa, #e3f2fd);
  font-family: "Tajawal", sans-serif;
}

.card {
  border-radius: 30px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s, box-shadow 0.3s;
  background: linear-gradient(to top, #ffffff, #f8f9fa);
}

.card:hover {
  transform: scale(1.03);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.carousel-inner img {
  border-radius: 15px;
}

.carousel-caption h5 {
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
}

.navbar {
  border-radius: 10px;
}

.nav-link {
  color: #296080 !important;
  transition: color 0.3s;
}

.nav-link:hover {
  color: #614900 !important;
}

.btn {
  border-radius: 15px;
  padding: 10px 20px;
  font-size: 1.1rem;
  transition: all 0.3s;
}

.btn-primary-soft {
  color: #296080;
  border: 1px solid #bbdefb;
}

.btn-primary-soft:hover {
  background-color: #296080;
  color: #fff;
  border: 1px solid #296080;
}

.loading-overlay {
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1050;
}

.spinner-border {
  width: 3.5rem;
  height: 3.5rem;
  border-width: 0.3rem;
}


.avatar:hover {
  border-color: #ffc107;
}


.text-date {
  font-size: 0.85rem;
  color: #6c757d;
}

.carousel-item {
  transition: transform 0.8s ease, opacity 0.8s ease;
}

.carousel-inner .active {
  animation: slideIn 0.8s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(50px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}


.post-images-container img {
  border-radius: 15px;
  transition: transform 0.3s, box-shadow 0.3s;
}

.post-images-container img:hover {
  transform: scale(1.01);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

.overlay {
  position: relative;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  border-radius: 10px;
  text-align: center;
  line-height: 100px;
}

.scroll-reveal {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease-in-out;
}

.scroll-reveal.visible {
  opacity: 1;
  transform: translateY(0);
}
</style>
